import {
	POST_WORKCENTER_LOCATION_COLABORATORS,
	POST_WORKCENTER_LOCATION_COLABORATORS_ERROR,
	POST_WORKCENTER_LOCATION_COLABORATORS_SUCCESS,
} from '../../../constants';

export const postWorkCenterLocationColaboratorReducer = (state, actions) => {
	switch (actions.type) {
		case POST_WORKCENTER_LOCATION_COLABORATORS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case POST_WORKCENTER_LOCATION_COLABORATORS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case POST_WORKCENTER_LOCATION_COLABORATORS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				workCenters: actions.payload,
			};
		default:
			return state;
	}
};
